import Swal from "sweetalert2/dist/sweetalert2.js";
import Head from "next/head";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { API_BASE_URL, API_BASEMOBIL_URL } from "../../libs/generalSettings";
import { postJSON, get } from "../../libs/services/request";
import Language from "../../locales/GetLanguageResourceResponse.json";
import { login, logout } from "../../redux/stores/auth";
import { encryptJson, decrypt } from "../../libs/encryption";
import { useRouter } from "next/router";
import { IsNullOrEmpty } from "../../libs/utils";
import Loader from "../../components/Loader";
import Image from "next/image";
const Register = () => {
  const router = useRouter();
  const [formValues, setFormValues] = useState({
    ad: "",
    soyad: "",
    adres: "",
    ilId: "-1",
    ilceId: "-1",
    sistem: "DESKTOP",
    tckn: "",
    telefon: "",
    ulke: "052",
    username: "",
  });
  const [activeValues, setActiveValues] = useState({
    otp: "",
    password: "",
    passwordAgain: "",
    telefon: "",
    username: "",
  });
  const [captchaId, setCaptchaId] = useState("");
  const [captcha, SetCaptcha] = useState([]);
  const [captchaEncode, SetCaptchaEncode] = useState([]);
  const [ulkeler, setUlkeler] = useState([]);
  const [iller, setIller] = useState([]);
  const [ilceler, setIlceler] = useState([]);
  const [loaderIsShow, setLoaderIsShow] = useState(false);
  const [illerShow, setIllerShow] = useState(true);
  const [ilcelerShow, setIlcelerShow] = useState(true);
  const [registerShow, setRegisterShow] = useState(true);
  const [activateShow, setActivateShow] = useState(false);
  const [text, setText] = useState("");
  const [userLogin, setUserLogin] = useState(false);
  const languageStore = useSelector((state) => state.language);
  const isLoggin = decrypt(useSelector((state) => state.auth.loggedIn));
  useEffect(() => {
    setUserLogin(isLoggin);
  }, [isLoggin]);
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    setLoaderIsShow(false);
    e.preventDefault();

    if (!IsNullOrEmpty(text)) {
      const base64String = Buffer.from(captcha.uuid + ";" + text).toString(
        "base64"
      );
      if (formValues.ulke !== "052") {
        if (
          IsNullOrEmpty(formValues.ad) ||
          IsNullOrEmpty(formValues.soyad) ||
          IsNullOrEmpty(formValues.adres) ||
          IsNullOrEmpty(formValues.telefon) ||
          IsNullOrEmpty(formValues.username)
        ) {
          Swal.fire({
            title: Language[languageStore].tumAlanlariDoldurun,
            icon: "error",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          GetCaptcha();
          setLoaderIsShow(true);
          return;
        } else {
        }
        postJSON(
          `${API_BASEMOBIL_URL}/users/sign-up?captchaDatasBase64=${base64String}&dil=${languageStore}`,
          formValues
        ).then((result) => {
          {
            setLoaderIsShow(true);
            if (result.sonuc === true) {
              setActivateShow(true);
              setRegisterShow(false);

              Swal.fire({
                title: result.sonucAciklama,
                icon: "info",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            } else if (result.sonucKodu === "07") {
              setLoaderIsShow(true);
              GetCaptcha();
              Swal.fire({
                title: Language[languageStore].GuvenlikKoduHata,
                icon: "error",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            } else {
              GetCaptcha();
              Swal.fire({
                title: result.sonucAciklama,
                icon: "error",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            }
          }
        });
      } else {
        if (
          IsNullOrEmpty(formValues.ad) ||
          IsNullOrEmpty(formValues.soyad) ||
          IsNullOrEmpty(formValues.adres) ||
          IsNullOrEmpty(formValues.telefon) ||
          IsNullOrEmpty(formValues.username) ||
          IsNullOrEmpty(formValues.ilceId) ||
          IsNullOrEmpty(formValues.ilId) ||
          formValues.ilceId == "-1" ||
          formValues.ilId == "-1"
        ) {
          Swal.fire({
            title: Language[languageStore].tumAlanlariDoldurun,
            icon: "error",
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading();
            },
          });
          GetCaptcha();
          setLoaderIsShow(true);
          return;
        } else {
        }
        postJSON(
          `${API_BASEMOBIL_URL}/users/sign-up?captchaDatasBase64=${base64String}&dil=${languageStore}`,
          formValues
        ).then((result) => {
          {
            setLoaderIsShow(true);
            if (result.sonuc === true) {
              setActivateShow(true);
              setRegisterShow(false);

              Swal.fire({
                title: result.sonucAciklama,
                icon: "info",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            } else if (result.sonucKodu === "07") {
              setLoaderIsShow(true);
              GetCaptcha();
              Swal.fire({
                title: Language[languageStore].GuvenlikKoduHata,
                icon: "error",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            } else {
              GetCaptcha();
              Swal.fire({
                title: result.sonucAciklama,
                icon: "error",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                  Swal.showLoading();
                },
              });
            }
          }
        });
      }
    } else {
      Swal.fire({
        title: Language[languageStore].GuvenlikKoduBosGecilemez,
        icon: "error",
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }
  };
  const handleActive = async (e) => {
    debugger;
    setLoaderIsShow(false);
    e.preventDefault();

    if (!IsNullOrEmpty(activeValues.otp)) {
      (activeValues.telefon = formValues.telefon),
        (activeValues.username = formValues.username);

      postJSON(
        `${API_BASEMOBIL_URL}/users/activateAccountAndSetPassword?captchaDatasBase64=t&dil=${languageStore}`,
        activeValues
      ).then((result) => {
        {
          setLoaderIsShow(true);
          if (result.sonuc === true) {
            router.push("/login");
            Swal.fire({
              title: result.sonucAciklama,
              icon: "info",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
              },
            });
          } else {
            Swal.fire({
              title: result.sonucAciklama,
              icon: "error",
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
              },
            });
          }
        }
      });
    } else {
      Swal.fire({
        title: Language[languageStore].GuvenlikKoduBosGecilemez,
        icon: "error",
        timer: 2000,
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }
  };
  const handleLogout = async () => {
    dispatch(logout());
  };
  useEffect(() => {
    (async () => {
      await get(`${API_BASE_URL}/getCaptcha`).then((result) => {
        {
          if (result.sonuc === true) {
            SetCaptcha(result.data);
            setLoaderIsShow(true);
          } else {
          }
        }
      });
    })();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await get(`${API_BASE_URL}/getUlkeler`);
        setUlkeler(result);
      } catch (error) {
        // Hata yönetimi
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await get(`${API_BASE_URL}/getiller`);
        setIller(result);
      } catch (error) {
        // Hata yönetimi
      }
    };

    fetchData();
  }, []);

  const IlceleriGetir = async (param) => {
    try {
      const result = await get(`${API_BASE_URL}/getilceler?ilId=${param}`);
      setIlceler(result);
    } catch (error) {
      // Hata yönetimi
    }
  };
  const UlkeKontrol = async (param) => {
    if (param === "052") {
      setIllerShow(true);
      setIlcelerShow(true);
    } else {
      setIllerShow(false);
      setIlcelerShow(false);
    }
  };

  const GetCaptcha = async () => {
    await get(`${API_BASE_URL}/getCaptcha`).then((result) => {
      {
        if (result.sonuc === true) {
          SetCaptcha(result.data);
          setLoaderIsShow(true);
        } else {
        }
      }
    });
  };
  return (
    <>
      <Head>
        <title>
          {Language[languageStore].webTitle} |{" "}
          {Language[languageStore].registerTitle}
        </title>
      </Head>
      {!loaderIsShow ? <Loader /> : ""}
      <section className="section-box mt-60">
        <div className="container">
          <div className="row mb-100">
            <div className="col-lg-1" />
            {userLogin ? (
              // <button onClick={handleLogout}>Çıkış Yap</button>
              <></>
            ) : (
              <div className="col-lg-5">
                <h3>{Language[languageStore].registerTitle}</h3>
                <p className="font-md color-gray-500">
                  {Language[languageStore].loginSloganTitle}
                </p>
                {registerShow && (
                  <form id="register-form" onSubmit={handleLogin}>
                    {" "}
                    <div className="form-register mt-30 mb-30">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {Language[languageStore].KullaniciBilgileriAd}
                            </span>
                            <input
                              className="form-control font-sm"
                              type="text"
                              name="ad"
                              value={formValues.ad}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  ad: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {Language[languageStore].KullaniciBilgileriSoyad}
                            </span>
                            <input
                              className="form-control font-sm"
                              type="text"
                              name="soyad"
                              value={formValues.soyad}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  soyad: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {Language[languageStore].KullaniciBilgileriAdres}
                            </span>
                            <input
                              className="form-control font-sm"
                              type="text"
                              value={formValues.adres}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  adres: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {Language[languageStore].KullaniciBilgileriUlke}
                            </span>
                            <select
                              className="form-control font-sm select-style1 color-gray-700"
                              id="select-ulkeler"
                              onChange={(e) => {
                                UlkeKontrol(e.target.value),
                                  setFormValues({
                                    ...formValues,
                                    ulke: e.target.value,
                                  });
                              }}
                            >
                              {ulkeler.map((ulke, uindex) => {
                                return (
                                  <option key={uindex} value={ulke.ulke_id}>
                                    {ulke.ulke_ad}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                        {illerShow && (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="mb-5 font-sm color-gray-700">
                                *&nbsp;
                              </label>
                              <span className="font-sm color-gray-500 font-medium">
                                {Language[languageStore].KullaniciBilgileriIl}
                              </span>
                              <select
                                className="form-control font-sm select-style1 color-gray-700"
                                id="select-iller"
                                onChange={(e) => {
                                  IlceleriGetir(e.target.value),
                                    setFormValues(
                                      e.target.value == "-1"
                                        ? {
                                            ...formValues,
                                            ilId: "-1",
                                          }
                                        : {
                                            ...formValues,
                                            ilId: e.target.value,
                                          }
                                    );
                                }}
                              >
                                {" "}
                                <option value="-1">
                                  {Language[languageStore].ilSeciniz}
                                </option>
                                {iller.map((il, iindex) => {
                                  return (
                                    <option key={iindex} value={il.il_id}>
                                      {il.il_ad}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}
                        {ilcelerShow && (
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label className="mb-5 font-sm color-gray-700">
                                *&nbsp;
                              </label>
                              <span className="font-sm color-gray-500 font-medium">
                                {Language[languageStore].KullaniciBilgileriIlce}
                              </span>
                              <select
                                className="form-control font-sm select-style1 color-gray-700"
                                id="select-ilceler"
                                onChange={(e) =>
                                  e.target.value == "-1"
                                    ? setFormValues({
                                        ...formValues,
                                        ilceId: "-1",
                                      })
                                    : setFormValues({
                                        ...formValues,
                                        ilceId: e.target.value,
                                      })
                                }
                              >
                                <option value="-1">
                                  {Language[languageStore].ilceSeciniz}
                                </option>
                                {ilceler.map((ilce, ilceindex) => {
                                  return (
                                    <option key={ilceindex} value={ilce.id}>
                                      {ilce.ilce_ad}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="form-group">
                            <span className="font-sm color-gray-500 font-medium">
                              {
                                Language[languageStore]
                                  .KullaniciBilgileriKimlikNo
                              }
                            </span>
                            <input
                              className="form-control font-sm"
                              type="text"
                              value={formValues.tckn}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  tckn: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {Language[languageStore].KullaniciBilgileriEposta}
                            </span>
                            <input
                              className="form-control font-sm"
                              type="email"
                              value={formValues.username}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  username: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form-group">
                            <label className="mb-5 font-sm color-gray-700">
                              *&nbsp;
                            </label>
                            <span className="font-sm color-gray-500 font-medium">
                              {
                                Language[languageStore]
                                  .KullaniciBilgileriCepTelefon
                              }
                            </span>

                            <input
                              className="form-control font-sm"
                              type="text"
                              value={formValues.telefon}
                              onChange={(e) =>
                                setFormValues({
                                  ...formValues,
                                  telefon: e.target.value,
                                })
                              }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-4">
                            {" "}
                            <div className="form-group">
                              <label className="color-gray-500 font-xs">
                                <label className="mb-5 font-sm color-gray-700">
                                  *&nbsp;
                                </label>
                                <img
                                  className="form-control"
                                  src={
                                    captcha.token &&
                                    `data:image/jpeg;base64, ${captcha.token}`
                                  }
                                  style={{ height: 70 }}
                                  alt="Base64 Image"
                                />{" "}
                                <a
                                  href="#"
                                  onClick={() => GetCaptcha()}
                                  className="form-control btn btn-info font-xs mt-2"
                                >
                                  {Language[languageStore].captchaYenileTitle}{" "}
                                </a>
                              </label>
                            </div>
                          </div>

                          <div className="col-md-8">
                            <div className="form-group">
                              <label className="mb-5 font-sm color-gray-700">
                                *&nbsp; {Language[languageStore].GuvenlikKodu}
                              </label>
                              <input
                                className="form-control"
                                type="text"
                                name="captcha"
                                style={{ height: 70 }}
                                required
                                placeholder={
                                  Language[languageStore].GuvenlikKodu
                                }
                                onChange={(e) => setText(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <button
                            className="font-md-bold btn btn-buy"
                            type="submit"
                          >
                            {Language[languageStore].registerGirisYapBtnTitle}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
                {activateShow && (
                  <form id="activate-form" onSubmit={handleActive}>
                    {" "}
                    <div className="form-register mt-30 mb-30">
                      <div className="row">
                        <div className="form-group">
                          <label className="mb-5 font-sm color-gray-700">
                            {Language[languageStore].registerDogrulamaKoduTitle}{" "}
                            *
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="******"
                            value={activeValues.otp}
                            required
                            onChange={(e) =>
                              setActiveValues({
                                ...activeValues,
                                otp: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label className="mb-5 font-sm color-gray-700">
                            {Language[languageStore].registerSifreTitle} *
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder={
                              Language[languageStore].sifrePlaceHolder
                            }
                            value={activeValues.password}
                            required
                            onChange={(e) =>
                              setActiveValues({
                                ...activeValues,
                                password: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <label className="mb-5 font-sm color-gray-700">
                            {Language[languageStore].registerSifreTekrarTitle} *
                          </label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="******************"
                            value={activeValues.passwordAgain}
                            required
                            onChange={(e) =>
                              setActiveValues({
                                ...activeValues,
                                passwordAgain: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="form-group">
                          <button
                            className="font-md-bold btn btn-buy"
                            type="submit"
                          >
                            {Language[languageStore].registerGirisYapBtnTitle}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            )}

            <div className="col-lg-5" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Register;
